// 互动相关

export default [
  {
    path: '/thunder/interact',
    name: 'interact',
    component: () => import('@/views/interact/interact_v2.vue'),
    meta: {
      title: '互动娱乐',
      notShowOrderList: true,
      level: 1,
    },
  },
  {
    path: '/thunder/aigc/create',
    name: 'aigc_create',
    component: () => import('@/views/aigc/create.vue'),
    meta: {
      title: '互动娱乐',
    },
  },
  {
    path: '/thunder/aigc/result',
    name: 'aigc_result',
    component: () => import('@/views/aigc/result.vue'),
    meta: {
      title: '互动娱乐',
    },
  },
  {
    path: '/thunder/aigc/history',
    name: 'aigc_history',
    component: () => import('@/views/aigc/history.vue'),
    meta: {
      title: '互动娱乐',
    },
  },
  {
    path: '/thunder/interact_pag',
    name: 'interact',
    component: () => import('@/views/interact/interact.vue'),
    meta: {
      title: '互动娱乐',
      notShowOrderList: true,
      level: 1,
    },
  },
  {
    path: '/thunder/pag',
    name: 'interactCollection',
    component: () => import('@/views/interact/collection'),
    children: [
      {
        path: 'aigc',
        name: 'aigc_pag',
        component: () => import('@/views/aigc/index.vue'),
        meta: {
          title: '互动娱乐',
        },
      },
      {
        path: 'gift_new',
        name: 'gift_pag_new',
        component: () => import('@/views/gift/gift_pag_new.vue'),
        meta: {
          title: '专属礼物',
        },
      },
      {
        path: 'photo',
        name: 'photo_pag',
        component: () => import('@/views/photo/photo_pag1'),
        meta: {
          title: '照片上屏',
        },
      },
      {
        path: 'bless/:id',
        name: 'bless_pag1',
        component: () => import('@/views/bless/bless_pag1.vue'),
        meta: {
          title: '互动娱乐',
        },
      },
      {
        path: 'gift',
        name: 'gift_pag',
        component: () => import('@/views/gift/gift_pag.vue'),
        meta: {
          title: '专属礼物',
        },
      },
      {
        path: 'aiphoto',
        name: 'aiphoto_pag',
        component: () => import('@/views/aiphoto/index.vue'), // 修改为 .vue 后缀
        meta: {
          title: '变装合影',
        },
      },
      {
        path: 'wallpaper',
        name: 'wallpaper_pag',
        component: () => import('@/views/wallpaper/list.vue'),
        meta: {
          title: '手机壁纸',
        },
      },
      {
        path: 'wallpaper',
        name: 'wallpaper_pag',
        component: () => import('@/views/wallpaper/list.vue'),
        meta: {
          title: '手机壁纸',
        },
      },
    ],
  },
  {
    path: '/thunder/nearby',
    name: 'nearby',
    component: () => import('@/views/nearby/nearby'),
    meta: {
      title: 'KTV交友',
      level: 1,
    },
  },
  {
    path: '/thunder/nearby/ktv',
    name: 'nearbyKtv',
    component: () => import('@/views/nearby/ktv'),
    meta: {
      title: '切换KTV',
    },
  },
  {
    path: '/thunder/nearby/comments',
    name: 'nearbyComments',
    component: () => import('@/views/nearby/comments'),
    meta: {
      title: '附近的人',
    },
  },
  {
    path: '/thunder/nearby/argument',
    name: 'nearbyArgument',
    component: () => import('@/views/nearby/argument'),
    meta: {
      title: '服务协议',
    },
  },
  {
    path: '/thunder/bar',
    name: 'bar',
    component: () => import('@/views/interact/bar.vue'),
    meta: {
      title: '互动娱乐',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/games_list',
    name: 'games_list',
    component: () => import('@/views/games/index.vue'),
    meta: {
      title: '随时玩游戏',
    },
  },
  {
    path: '/thunder/gold_charter',
    name: 'gold_charter',
    redirect: '/thunder/home',
  },
  {
    path: '/thunder/vip-collection',
    name: 'vipCollection',
    component: () => import('@/views/activity/vip-collection/index.vue'),
    meta: {
      title: 'VIP热歌榜',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/square/agreement',
    name: 'squareAgreement',
    component: () => import('@/views/square/agreement.vue'),
    meta: {
      title: '用户协议',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/video',
    name: 'video',
    component: () => import('@/views/activity/video/index.vue'),
    meta: {
      title: '视频',
      level: 1,
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/interact',
    name: 'interact',
    component: () => import('@/views/interact/interact_v2.vue'),
    meta: {
      title: '互动娱乐',
      notShowOrderList: true,
      level: 1,
    },
  },
];
